import React, { FC, useCallback } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { useAuthState } from 'state/auth';
import { Dropdown } from 'common/dropdown';
import { RoutesSettings, AUTH_TOKEN } from 'config/index';
import { useNavigate } from 'react-router';
import { DownArrowIcon, VehicleIcon } from 'common/icons';
import { removeFromLocalStorage } from 'global/utils/storage';
import { HeaderActionsProps } from './header-actions.types';

import styles from './header-actions.module.scss';

export const HeaderActions: FC<HeaderActionsProps> = props => {
  const navigate = useNavigate();
  const { isAuthenticated, onLogout, user: userInfo } = useAuthState();
  const { className } = props;

  const onSignOut = useCallback(() => {
    removeFromLocalStorage(AUTH_TOKEN);
    onLogout();
    navigate(RoutesSettings.signIn, { replace: true });
  }, []);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <ul className={clsx(styles.options, className)}>
      <li className={styles.navLink}>
        <Link className="mr-3 flex items-center gap-2" to="/">
          <VehicleIcon size={25} />
          <span>Mis Vehículos</span>
        </Link>
      </li>

      <li className={styles.userNameContainer}>
        <Dropdown items={[{ id: 'logout', label: 'Cerrar sesión' }]} onSelectItem={() => onSignOut()}>
          <span>{userInfo.fullName}</span>
          <DownArrowIcon className="ml-2" fontSize="small" />
        </Dropdown>
      </li>
    </ul>
  );
};

HeaderActions.defaultProps = {
  isAuthenticated: false,
  onSignOut: () => {},
} as any;

export default React.memo(HeaderActions);
